import environmentSettings from "@constants/environmentSettings";

const { contentManagementUrl, contentToken } = environmentSettings;

export const CONTENT_URL = contentManagementUrl;
export const CONTENT_TOKEN = contentToken;
export const HELP_CONTENT = "/api/help-entries?populate=*";
export const BANNER_CONTENT = "/api/banner-messages?populate=*";
export const ACCOUNT_NOTIFICATION = "/api/account-messages?populate=*";